<template>
  <div class='login_wrap vue_flex vue_column vue_flex_around vue_align_end size_no_repeat' :style="{'width': innerWidth + 'px', 'height': innerHeight + 'px'}">
      <div class="login_wrap_boxs vue_flex vue_column vue_flex_between">
        <div class="login_wrap_boxs_title vue-font-fangyuehei-400 vue_relative">
          广厦OA管理系统
          <img src="@/assets/images/arrow-go-back-fill.png" alt="" class="vue_absolute" @click="loginClick('login')">
        </div>
        <div class="login_wrap_boxs_div vue_flex_item vue_flex vue_column vue_align_center">
          <p class="login_wrap_boxs_div_text vue-font-PingFang-bold">注册</p>
          <div class="login_wrap_boxs_div_input vue_flex vue_column vue_flex_around width_100">
            <div class="vue_flex">
              <img src="@/assets/images/ic_sj.png" alt="">
              <input type="text" v-model="tempObj.phone" placeholder="请输入手机号" class="vue-font-PingFang-400">
            </div>
          </div>
          <div class="login_wrap_boxs_div_input vue_flex vue_column vue_flex_around width_100">
            <div class="vue_flex">
              <img src="@/assets/images/ic_yhm.png" alt="">
              <input type="text" v-model="tempObj.name" placeholder="请输入用户名" class="vue-font-PingFang-400">
            </div>
          </div>
          <div class="login_wrap_boxs_div_input vue_flex vue_column vue_flex_around width_100">
            <div class="vue_flex">
              <img src="@/assets/images/ic_mm.png" alt="">
              <input type="text" v-model="tempObj.pass" placeholder="请输入密码" class="vue-font-PingFang-400">
            </div>
          </div>
          <div class="login_wrap_boxs_div_input vue_flex vue_column vue_flex_around width_100">
            <div class="vue_flex">
              <img src="@/assets/images/ic_mm.png" alt="">
              <input type="text" v-model="tempObj.againpass" placeholder="请再次输入密码" class="vue-font-PingFang-400">
            </div>
          </div>
          <div class="login_wrap_boxs_div_input vue_flex vue_column vue_flex_around width_100">
            <div class="vue_flex">
              <img src="@/assets/images/ic_gs.png" alt="">
              <el-select v-model="tempObj.company" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="login_wrap_boxs_div_p width_100 vue-font-PingFang-400" @click="loginClick('login')">登录</div>
          <div class="login_wrap_boxs_div_but vue-font-PingFang-500" @click="loginClick('register')">注册</div>
        </div>
      </div>
  </div>
</template>
<script>
import jsmd5 from 'js-md5'
import { windowFun } from "@/utils/utils"
import DonMessage from "@/utils/message";
export default {
  data(){
      return{
        loginName:'test01',
        innerWidth: 0,
        innerHeight: 0,
        tempObj: {
          phone: '',
          name: '',
          pass: '',
          againpass: '',
          company: '',
        },

        options: [{
          value: '选项1', label: '黄金糕'
        }, {
          value: '选项2', label: '双皮奶'
        }, {
          value: '选项3', label: '蚵仔煎'
        }, {
          value: '选项4', label: '龙须面'
        }, {
          value: '选项5', label: '北京烤鸭'
        }],
      }
  },

  created(){
    this.innerWidth = windowFun().innerWidth
    this.innerHeight = windowFun().innerHeight
  },
  methods:{
    async loginClick(type){
      // const res = await this.$http.post(this.$urls.login,{});
      // console.log(res);
      if(type === 'register'){
        if(!this.tempObj.phone) return DonMessage.error(`请输入手机号`);
        if(!this.tempObj.name) return DonMessage.error(`请输入用户名`);
        if(!this.tempObj.pass) return DonMessage.error(`请输入密码`);
        if(!this.tempObj.againpass) return DonMessage.error(`再次输入密码`);
        if(this.tempObj.pass !== this.tempObj.againpass) return DonMessage.error(`密码验证失败，请从重新输入`);
        if(!this.tempObj.company) return DonMessage.error(`请选择公司`);
      } else {
        this.$router.push({ path: `/${type}` });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login_wrap{
  background-image: url("../../assets/images/ic_dl_bg.png");
  .login_wrap_boxs{
    width: 543px;
    height: 860px;
    margin-right: 222px;
    background: #2274EF;
    box-shadow: 0px 0px 48px 0px rgba(5,42,97,0.2);
    border-radius: 30px;
    .login_wrap_boxs_title{
      font-size: 30px;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
      margin: 41px 0px 37px;
      text-align: center;
      img{
        width: 36px; height: 36px; top: 0px; left: 26px;
      }
    }
    .login_wrap_boxs_div{
      background: rgba(255, 255, 255, 1); border-radius: 30px; padding: 0px 58px;
      .login_wrap_boxs_div_text{
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        margin: 41px 0px 44px;
      }
      .login_wrap_boxs_div_input{
        height: 74px; background: rgba(245, 249, 252, 1); border-radius: 9px; padding-left: 27px;
        margin-bottom: 16px;
        img{
          width: 36px; height: 36px;
        }
        input{
          font-size: 16px; margin-left: 15px;
        }
      }
      .login_wrap_boxs_div_p{
        margin: 7px 0px 0px;
        padding: 0px 13px;
        text-align: right;
        font-size: 16px;
        color: rgba(104, 127, 150, 1);
        line-height: 16px;
        cursor: pointer;
      }
      .login_wrap_boxs_div_but{
        width: 408px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        background: #2274EF;
        border-radius: 33px;
        margin: 45px auto 0px;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
}

/deep/.el-select{
  width: -webkit-fill-available !important;
}
.el-select /deep/.el-input__inner{
  border: none !important;
  background: none !important;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/pages/register/register.vue